import React from 'react';
import {render} from 'react-dom';
import IntentGate from './intentGate.jsx';
import CmsService from '../js/cmsService.js';
import UseCasesScreen from './useCasesScreen.jsx';
import StartWalkThroughModal from './startWalkThroughModal.jsx';
import Header from './header.jsx';
import LocalStorageService from '../js/localStorageService.js';
import PreferenceService from '../js/preferenceService.js';
import SessionService from '../js/sessionService.js';
import {getEffectiveLicenses} from '../js/licenseService';
import IntentGateHeader from './intentGateHeader.jsx';
import PostWalkthroughExitPage from '../jsx/postWalkthroughExitPage.jsx';
import * as constants from '../js/constants.js';
import {logMessageToServer} from '../js/loggerService';

// So that trialPortal Use cases screen does not crash
window.infaWalkMe = {};

const SHOW_PRODUCTS_PATH = "/cloudshell/showProducts";
const fullyQualifiedNameForProjects = "IntentGate.selected.projects";
const fullyQualifiedNameForSources = "IntentGate.selected.sources";
const fullyQualifiedNameForTrial = "IntentGate.skipTrial";

const cmsService = new CmsService();

cmsService.init(cmsConfig.spaceId, cmsConfig.accessToken);
const localStorageService = new LocalStorageService();
let preferenceService = new PreferenceService();
let sessionService = new SessionService();

window.walkme_event = function(event) {
    if (event.Type === "wm_walkmeLibLoaded") { //WalkMe loaded
        setTimeout(function() { // TODO: Find a better way to hide walkme player
            WalkMePlayerAPI.hidePlayer();
        }, 1000);
    }
}

class App extends React.Component {

  constructor(props) {
    super(props);

    const { selectedProjectTypes, selectedSourceTypes} = props;

    const hasSelectedProjects = selectedProjectTypes.length !== 0;
    const hasSelectedSources = selectedSourceTypes.length !== 0;

    let initialPage = constants.PROJECTS_PAGE;

    if (hasSelectedProjects) {
      initialPage = constants.SOURCES_PAGE;
      if (hasSelectedSources) {
        initialPage = constants.USE_CASES_PAGE;
      }
    }

    this.sessionService = new SessionService();

    this.state = {
      useCases: [],
      projectTypes: [],
      sourceTypes: [],
      selectedProjectTypes,
      selectedSourceTypes,
      hasSelectedProjects,
      hasSelectedSources,
      selectedUseCase: null,
      currentPage: initialPage,
      layout: null
    };
  }

  componentDidMount() {
    this.sessionService.isSessionValid()
      .then(response => {
        this.setState({ sessionInfo: response }, () => {
          
          getEffectiveLicenses(this.state.sessionInfo.currentOrgId)
            .then((resp) => {
              const licenses = resp.active.map(license => license.name);
              this.setState({ licenses }, () => {
                cmsService.getProjectTypes().then(projectTypes => {
                  const licensedProjectTypes = projectTypes
                    .filter(projectType => {
                      return this.state.licenses ? this.state.licenses.includes(projectType.licenseName) : true;
                    });

                  this.setState({ projectTypes: licensedProjectTypes });

                  if (this.state.projectTypes.length === 1) {
                    this.handleProjectTypeSelected(this.state.projectTypes.map(pt => pt.tag));
                  }

                }).catch((e) => {
                  this.logCMSErrorMessageAndExit("Error caused while fetching project types from contentful.");
                });
              });
            })
            .catch((err) => {
              logMessageToServer("ERROR","TRIAL-LICENSE","Unable to fetch effective licenses");
            });
        });
      })
      .catch(() => {
        logMessageToServer("ERROR","TRIAL-SESSION","Unable to fetch sessionInfo");
      });

    cmsService.getSourceTypes().then(sourceTypes => {
      this.setState({ sourceTypes, allSourceTypes: sourceTypes });
    }).catch((e) => {
      this.logCMSErrorMessageAndExit("Error caused while fetching source types from contentful.");
    });
    cmsService.getLayout().then(layout => {
      this.setState({ layout });
    }).catch((e) => {
      this.logCMSErrorMessageAndExit("Error cause while fetching layout type from contentful");
    });
  }

  logCMSErrorMessageAndExit = (message) => {
    logMessageToServer("ERROR", "TRIAL-CONTENTFUL", message);
    this.handleExitIntentGate();
  };

  handleUseCaseAction = (action, useCaseId) => {
    switch (action) {
      case 'SHOW_ME':
        let walkthroughId;
        var that = this;
        let usecase;
        cmsService.getUseCases().then(function (useCases) {
          for (let i = 0; i < useCases.length; i += 1) {
            let useCaseData = useCases[i];
            if (useCaseData.id === useCaseId) {
              usecase = useCaseData;
              walkthroughId = useCaseData.walkthroughId;
              break;
            }
          }
          localStorageService.storeData('useCaseToDemo', { useCaseId, walkthroughId});
          that.setState({selectedUseCase : usecase});
        });
        break;
      case 'PLAY_VIDEO':
        let videoUrl;
        cmsService.getUseCases().then(function (useCases) {
          for (let i = 0; i < useCases.length; i += 1) {
            let useCaseData = useCases[i];
            if (useCaseData.id === useCaseId) {
              videoUrl = useCaseData.videoUrl;
              break;
            }
          }
          logMessageToServer("INFO","TRIAL","Started Playing video from "+videoUrl +" for use case "+useCaseId);
          window.open(videoUrl, '_blank');
        });
        break;
      case 'CONTACT_ME':
        let contactMeUrl = 'https://www.informatica.com/cloud-contact-us.html';
        logMessageToServer("INFO","TRIAL","User clicked on contact me for use case "+useCaseId);
        window.open(contactMeUrl, '_blank');
        break;
    }
  }


  handleProjectTypeSelected = (selectedProjectTypes) => {
    preferenceService.storeData(fullyQualifiedNameForProjects, selectedProjectTypes, this.state.hasSelectedProjects).then(() => {
      preferenceService.storeData(fullyQualifiedNameForSources, [], this.state.hasSelectedSources).then(() => {
        this.updateIntents(selectedProjectTypes);
      });
    });
    logMessageToServer("INFO","TRIAL","User's Project Types Selected");
  }

  updateIntents = (selectedProjectTypes) => {
    this.setState({
      selectedProjectTypes,
      hasSelectedProjects: selectedProjectTypes.length !== 0,
      currentPage: constants.SOURCES_PAGE,
      sourceTypes: this.state.allSourceTypes.filter((source) => this.shouldSourceBeShown(source, selectedProjectTypes)),
      selectedSourceTypes: [],
      hasSelectedSources: true // This means source type preference has been created by the user
    }, () => {
      if (this.state.sourceTypes.length === 1) {
        this.handleSourceTypeSelected(this.state.sourceTypes.map(st => st.tag));
      }
    });
  };

  shouldSourceBeShown = (source, selectedProjectTypes) => {
    if (source.filterKeys && source.filterKeys.length > 0) {
      const filterKeys = source.filterKeys;
      const projectTags = filterKeys
        .filter(projectType => projectType.fields !== undefined) // Needed in case the linked entries are not published in Contentful
        .map(projectType => {
          return projectType.fields.tag
        });

      return selectedProjectTypes.some( projectType => projectTags.includes(projectType));
    }
    return false;
  };

  handleSourceTypeSelected = (selectedSourceTypes) => {
      preferenceService.storeData(fullyQualifiedNameForSources, selectedSourceTypes, this.state.hasSelectedSources).then(() => {
        this.setState({
          selectedSourceTypes: selectedSourceTypes,
          currentPage: constants.USE_CASES_PAGE
        });
      });
    logMessageToServer("INFO","TRIAL","User's Source Types Selected");
  }

  handleExitIntentGate = () => {
    this.handleSkipTrialPortal();
    window.location.href = SHOW_PRODUCTS_PATH;
  }

  handleSkipTrialPortal = () => {
      preferenceService.storeData(fullyQualifiedNameForTrial, 'true', false)
        .then(()=> {
            window.location.href = SHOW_PRODUCTS_PATH;
        });
    logMessageToServer("INFO","TRIAL","User's skipping trial portal");
  }

  handleBackButton = () => {
    this.handleChangePage(constants.SOURCES_PAGE);
  }

  handleChangePage = (page) => {
    this.setState({
      currentPage: page
    });
  }

  getContent() {
    if (this.state.currentPage === constants.USE_CASES_PAGE) {
      return (
        <UseCasesScreen
          key='useCases'
          content={this.state.layout.content.useCases}
          headerContent={this.state.layout.header}
          onUseCaseAction={this.handleUseCaseAction}
          selectedProjectTypes={this.state.selectedProjectTypes}
          selectedSourceTypes={this.state.selectedSourceTypes}
          onSkip={this.handleSkipTrialPortal}
          onBack={this.handleBackButton} />);
    } else {
      return (
          <div className='intent-gate-container'>
            <IntentGateHeader 
              content={this.state.layout.header}
              currentPage={this.state.currentPage}
              onPageChanged={this.handleChangePage}
              onSkip={this.handleSkipTrialPortal}/>
            <div className='cool-background'>
                { this.getIntentGateContent() }
            </div>
          </div>
      );
    }
  }

  getIntentGateContent() {
    if (this.state.currentPage === constants.PROJECTS_PAGE) {
      return (
        <IntentGate
          key='projectTypes'
          title={this.getDataProjectTypeTitle()}
          subTitle={this.getDataProjectTypeSubTitle()}
          content={this.state.layout.content}
          footer={this.state.layout.footer}
          intents={this.state.projectTypes}
          selectedProjectTypes={this.state.selectedProjectTypes}
          selectedSourceTypes={this.state.selectedSourceTypes}
          currentPage={this.state.currentPage}
          onContinue={this.handleProjectTypeSelected}/>);
    } else {
      return (
        <IntentGate
          key='sourceType'
          title={this.getSourceTargetTypeTitle()}
          subTitle={this.getSourceTargetTypeSubTitle()}
          content={this.state.layout.content}          
          footer={this.state.layout.footer}
          intents={this.state.allSourceTypes.filter((source) => this.shouldSourceBeShown(source, this.state.selectedProjectTypes))}
          selectedProjectTypes={this.state.selectedProjectTypes}
          selectedSourceTypes={this.state.selectedSourceTypes}
          onContinue={this.handleSourceTypeSelected}
          currentPage={this.state.currentPage}/>);
    }
  }

  getDataProjectTypeTitle = () => {
    return this.state.layout.content.dataProjectType.title;
  };

  getDataProjectTypeSubTitle = () => {
    return this.state.layout.content.dataProjectType.subTitle;
  };

  getSourceTargetTypeTitle = () => {
    return this.state.layout.content.sourceTargetType.title;
  };

  getSourceTargetTypeSubTitle = () => {
    return this.state.layout.content.sourceTargetType.subTitle;
  };

  getStartOfWalkthroughModal = () => {
    if(this.state.selectedUseCase) {
      if (infaWalkMe.loaded) {
        return this.renderStartWalkthroughModal();
      } else {
          //WalkMe is not available
        return this.renderPostWalkthroughExitModal();
      }
    } else {
      return "";
    }
  };

  renderStartWalkthroughModal = () => {
    return (
      <StartWalkThroughModal
        content={this.state.layout.content.useCases.preWalkthroughModal}
        selectedUseCase={this.state.selectedUseCase}
        hide={this.hideStartOfWalkthrough}
        gotoWalkthrough={this.redirectToWalkthrough}/>
    );
  };

  renderPostWalkthroughExitModal = () => {
    return (
      <PostWalkthroughExitPage
        content={this.state.layout.content.useCases.postWalkthroughExitModal}
        selectedUseCase={this.state.selectedUseCase}
        walkthrough={document.getElementById('walkthrough')}
        walkThroughError="true"
        hide={this.hideStartOfWalkthrough} />
    );
  };

  redirectToWalkthrough = () => {
    sessionService.isSessionValid().then(dataObj => {
        window.location.pathname = this.state.selectedUseCase.relativeProductPath;
    }).catch(dataObj => {
        localStorageService.remove('useCaseToDemo');
        window.location.pathname = this.state.selectedUseCase.relativeProductPath;
    });
  };


  hideStartOfWalkthrough = () => {
    this.setState({selectedUseCase : null});
    localStorageService.remove('useCaseToDemo');
  };


  render() {
    return (
      <div className='app'>
        <Header onSkip={this.handleSkipTrialPortal}/>
        <div className='main-content'>
          {this.state.layout && this.getContent()}
        </div>
        <div>{this.getStartOfWalkthroughModal()}</div>
      </div>
    );
  }
}


export default App;